import { RunnerModularWorkflowStep } from 'features/modular-workflow/runner/types-runner';

export const isStepInProgress = (step?: RunnerModularWorkflowStep) =>
  ['in_progress', 'in_queue'].includes(step?.status ?? '');
